import {useProduct} from '@salesforce/commerce-sdk-react'
import {ProductTileCms} from 'hec/components/product-tile-cms'
import React from 'react'
import {formatProductDataForTile} from './utils'
interface ProductTileProps {
    attributes?: {
        className?: string
        [key: string]: any
    }
    product: {
        options?: {
            product?: string
        }
        data?: any
    }
    enableQuickView: boolean
    addedToCartPodId: string
    accountFormLabels: any
}

export const ProductTile: React.FC<ProductTileProps> = (props) => {
    const {product, addedToCartPodId, enableQuickView, attributes} = props
    const {className, ...restAttributes} = attributes || {}
    const productId = (product?.options?.product || product?.data?.id || '') as string
    const shouldQueryProductData = (productId && !product?.data) || false

    const {
        isLoading: productIsLoading,
        error: productResultError,
        data: productResult
    } = useProduct(
        {
            parameters: {
                id: productId || '',
                allImages: true
            }
        },
        {enabled: shouldQueryProductData}
    )

    if ((productIsLoading || !productResult) && shouldQueryProductData) {
        return null
    }
    if (productResultError) {
        console.error(`There was an issue fetching product data for product ID: ${productId}`)
    }

    const productData = shouldQueryProductData ? productResult : product?.data

    const formattedProductData = formatProductDataForTile(productData)

    return (
        <ProductTileCms
            product={formattedProductData}
            isAddToCart={false}
            enableQuickView={enableQuickView}
            addedToCartPodId={addedToCartPodId}
            className={className}
            {...restAttributes}
            data-testid="productTile-ProductTileCms"
        />
    )
}

export const ProductTileDefinition = {
    component: ProductTile,
    name: 'ProductTile',
    noWrap: true,
    inputs: [
        {
            name: 'product',
            type: 'SFCommerceProduct',
            required: true
        },
        {
            name: 'enableQuickView',
            type: 'boolean',
            required: true,
            defaultValue: false
        },
        {
            name: 'addedToCartPodId',
            type: 'string',
            required: true
        }
    ]
}
